import { render, staticRenderFns } from "./SocialIdentities.vue?vue&type=template&id=b83f6424&scoped=true"
import script from "./SocialIdentities.vue?vue&type=script&lang=js"
export * from "./SocialIdentities.vue?vue&type=script&lang=js"
import style0 from "./SocialIdentities.vue?vue&type=style&index=0&id=b83f6424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83f6424",
  null
  
)

export default component.exports